(function (angular, app) {
    "use strict";

    // Heading
    angular.module(app.modules.view.name)
       .directive(app.modules.view.directives.my, myDirective);

    myDirective.$inject = ["$window", "$q", "$timeout", "$routeParams", "$sce"
         , app.modules.common.constants.appsettings
        , app.modules.common.services.functions
        , app.modules.common.services.storage
        , app.modules.invitation.services.invite
        , app.modules.group.services.groups
        , app.modules.outing.services.outings
        , app.modules.scoring.services.score
        , app.modules.handicap.services.handicaps
        , app.modules.ui.services.alerts
        , app.modules.ui.services.ui
        , app.modules.member.services.search
    ];

    function myDirective($window, $q, $timeout, $routeParams, $sce
        , ggSettings
       , ggFunctions
       , ggStorage
       , ggInvitations
       , ggGroupSvc
       , ggOutingSvc
       , ggScoringSvc
       , ggHandicapSvc
       , ggAlertSvc
       , ggUISvc
       , ggMemberSearchSvc) {
        return {
            restrict: "E"
           , templateUrl: "app/view/directives/my.html"
           , link: function ($scope, element, attrs) {


               $scope.PopupAlert = new ggAlertSvc.popup;

               var ctrl = this;

               // In app purchase
               var inIOSPurchase = {};

               $scope.Temp = {
                   isLoaded: false
                  , isWelcome: false
                  , isSwiper: false
                  , loadCalendar: false
                  , isJumboExpanded: false
                  , member: {
                      name: ""
                     , region: ""
                     , city: ""
                  }
                  , upgrade: {
                      isOnline: false
                     , isRequired: false
                     , isAvailable: false
                     , isSearch: false
                     , isIOSPurchase: 1
                     , isIOS: false
                     , reason: ""
                     , club: {}
                  }
                   , profile: {
                       isUpdate: false
                       , name: false
                       , email: false
                       , phone: false
                       , address: false
                   }
               }


               $scope.View = {
                   tabs: {
                       current: 5
                      , types: {
                          home: 1
                         , scoring: 2
                         , groups: 3
                         , outings: 4
                         , handicap: 5
                      }
                      , select: function (v, v2) {

                          if (!v) {
                              v = $scope.View.tabs.current;
                          }


                          $scope.View.tabs.current = v; // Set Current
                          app.Member.Session.bookmark.home.tab = v; // Remember selected tab
                          $scope.f.scrollLimit.reset(); // Reset Scroll limit

                          if (v == $scope.View.tabs.types.home) {
                              $scope.Content.home.tabs.select(v2);
                          }

                          if (v == $scope.View.tabs.types.scoring) {
                              $scope.Content.scoring.tabs.select(v2);
                          }

                          if (v == $scope.View.tabs.types.outings) {
                              $scope.Content.outings.tabs.select(v2);
                          }

                          if (v == $scope.View.tabs.types.groups) {
                              $scope.Content.groups.tabs.select(v2);
                          }

                      }
                      , isActive: function (v) {
                          return v == $scope.View.tabs.current;
                      }
                   }
               }

               $scope.Content = {
                   init: function () {
                       if (!$scope.Temp.isLoaded) {

                           // Member Image
                           $scope.Temp.member.image = app.Branding.logoSq;

                           if (app.Member.Detail["photo@odata.mediaReadLink"] && app.Member.Detail["photo@odata.mediaReadLink"] != "") {
                               $scope.Temp.member.image = app.Member.Detail["photo@odata.mediaReadLink"];
                           }

                           // Last Tab
                           var tab1 = app.Member.Session.bookmark.home.tab;
                           var tab2 = app.Member.Session.bookmark.home.tab2;

                           $scope.View.tabs.select(tab1, tab2);
                           ggFunctions.scrollToTop(0);

                           /*
                           var _clubs = function () {
                               return $scope.Content.clubs.fetch();
                           }
                           var _revision = function () {
                               return $scope.Content.handicap.revision.fetch();
                           }
                           var _inprogress = function () {
                               return $scope.Content.scoring.inProgress.fetch()
                           }
       
                           
                           _clubs().then(function () {
                               return _revision();
                           }).then(function () {
                               return _inprogress();
                           }).finally(function () {
                               $scope.Temp.isLoaded = true;
                           });
                           */

                           // Validate Profile information

                           // Mobile Phone
                           if (app.Member.Detail.mobilePhone && app.Member.Detail.mobilePhone != "") {
                               if (isNaN(app.Member.Detail.mobilePhone)) {
                                   $scope.Temp.profile.isUpdate = true;
                                   $scope.Temp.profile.phone = true;
                               }
                           }

                           // EmailAddress
                           if (!app.Member.Detail.email || (app.Member.Detail.email && !ggFunctions.isEmailValid(app.Member.Detail.email))) {
                               $scope.Temp.profile.isUpdate = true;
                               $scope.Temp.profile.email = true;
                           }

                           // FirstName // LastName
                           if (!app.Member.Detail.firstName || (app.Member.Detail.firstName && app.Member.Detail.firstName == "")) {
                               $scope.Temp.profile.isUpdate = true;
                               $scope.Temp.profile.name = true;
                           }
                           if (!app.Member.Detail.lastName || (app.Member.Detail.firstName && app.Member.Detail.lastName == "")) {
                               $scope.Temp.profile.isUpdate = true;
                               $scope.Temp.profile.name = true;
                           }

                           // address -- At least City, PostalCode
                           if (!app.Member.Detail.address.postalCode || (app.Member.Detail.address.postalCode && app.Member.Detail.address.postalCode == "")) {
                               $scope.Temp.profile.isUpdate = true;
                               $scope.Temp.profile.address = true;
                           }
                           if (!app.Member.Detail.address.region || (app.Member.Detail.address.region && app.Member.Detail.address.region == "")) {
                               $scope.Temp.profile.isUpdate = true;
                               $scope.Temp.profile.address = true;
                           }
                           if (!app.Member.Detail.address.city || (app.Member.Detail.address.city && app.Member.Detail.address.city == "")) {
                               $scope.Temp.profile.isUpdate = true;
                               $scope.Temp.profile.address = true;
                           }
                           if (!app.Member.Detail.address.line1 || (app.Member.Detail.address.line1 && app.Member.Detail.address.line1 == "")) {
                               //$scope.Temp.profile.isUpdate = true;
                               //$scope.Temp.profile.address = true;
                           }


                           $scope.Content.clubs.loadProfile();
                           $scope.Content.scoring.inProgress.fetch();
                           $scope.Temp.isLoaded = true;
                       }
                   }
                  , home: {
                      tabs: {
                          current: 1
                         , types: {
                             home: 1
                         }
                         , isActive: function (t) {
                             return t == $scope.Content.home.tabs.current;
                         }
                         , select: function (t) {
                             if (!t) {
                                 t = $scope.Content.home.tabs.current;
                             }
                             $scope.Content.home.tabs.current = t;
                         }
                      }
                  }
                  , outings: {
                      tabs: {
                          current: 3
                         , types: {
                             player: 1
                            , organizer: 2
                            , playerOrOrganizer: 3
                            , group: 4
                         }
                         , isActive: function (t) {
                             return t == $scope.Content.outings.tabs.current;
                         }
                         , select: function (t) {

                             if (!t) {
                                 t = $scope.Content.outings.tabs.current;
                             }

                             if (t == $scope.Content.outings.tabs.types.player) {
                                 $scope.Content.outings.player.fetch();
                             }
                             if (t == $scope.Content.outings.tabs.types.organizer) {
                                 $scope.Content.outings.organizer.fetch();
                             }
                             if (t == $scope.Content.outings.tabs.types.playerOrOrganizer) {
                                 $scope.Content.outings.playerOrOrganizer.fetch();
                             }
                             if (t == $scope.Content.outings.tabs.types.group) {
                                 $scope.Content.outings.groups.fetch();
                             }

                             $scope.Content.outings.tabs.current = t;
                             app.Member.Session.bookmark.home.tab2 = t; // Remember Second tab.
                             $scope.f.scrollLimit.reset(); // Reset Scroll limit
                         }
                      }
                     , player: {
                         results: []
                        , news: []
                        , olds: []
                        , isLoaded: false
                        , fetch: function (isRefresh) {
                            var processData = function (results) {
                                var news = [];
                                var olds = [];
                                var tmp = [];
                                if (results.length > 0) {
                                    // Sort on date
                                    results.sort(function (a, b) {
                                        var d1 = new Date(b.startOn);
                                        var d2 = new Date(a.startOn);

                                        var v = d1 > d2 ? 1 : d1 < d2 ? -1 : 0;
                                        return v;
                                    });

                                    for (var o = 0; o < results.length; o++) {
                                        if (results[o].status == "Active") {
                                            tmp.push(results[o]);
                                        }
                                    }

                                    var today = new Date(ggFunctions.formatDateString(null, 'yyyy-mm-dd', true));

                                    for (var t = 0; t < tmp.length; t++) {
                                        var cDate = new Date(ggFunctions.formatDateString(tmp[t].startOn, 'yyyy-mm-dd', true));
                                        if (cDate >= today) {
                                            news.push(tmp[t]);
                                        } else {
                                            olds.push(tmp[t]);
                                        }
                                    }

                                }
                                $scope.Content.outings.player.results = tmp;
                                $scope.Content.outings.player.news = news;
                                $scope.Content.outings.player.olds = olds;
                                $scope.Content.outings.player.isLoaded = true;
                                return $q.when();
                            }


                            return app.Member.Network.Data.Outings.player.fetch(true).then(function (data) {
                                return processData(data);
                            });

                        }
                     }
                     , organizer: {
                         results: []
                        , news: []
                        , olds: []
                        , isLoaded: false
                        , fetch: function (isRefresh) {
                            var processData = function (results) {

                                var news = [];
                                var olds = [];
                                var tmp = [];
                                if (results.length > 0) {
                                    // Sort on date
                                    results.sort(function (a, b) {
                                        var d1 = new Date(b.startOn);
                                        var d2 = new Date(a.startOn);

                                        var v = d1 > d2 ? 1 : d1 < d2 ? -1 : 0;
                                        return v;
                                    });
                                }

                                for (var o = 0; o < results.length; o++) {
                                    if (results[o].status == "Active") {
                                        tmp.push(results[o]);
                                    }
                                }

                                var today = new Date(ggFunctions.formatDateString(null, 'yyyy-mm-dd', true));

                                for (var t = 0; t < tmp.length; t++) {
                                    var cDate = new Date(ggFunctions.formatDateString(tmp[t].startOn, 'yyyy-mm-dd', true));
                                    if (cDate >= today) {
                                        news.push(tmp[t]);
                                    } else {
                                        olds.push(tmp[t]);
                                    }
                                }

                                $scope.Content.outings.organizer.results = tmp;
                                $scope.Content.outings.organizer.news = news;
                                $scope.Content.outings.organizer.olds = olds;
                                $scope.Content.outings.organizer.isLoaded = true;
                                return $q.when();
                            }


                            return app.Member.Network.Data.Outings.organizer.fetch(true).then(function (data) {
                                return processData(data);
                            });
                        }
                     }
                     , playerOrOrganizer: {
                         results: []
                         , filter: ""
                        , isLoaded: false
                        , fetch: function (isRefresh) {
                            var processData = function (results) {
                                $scope.Content.outings.playerOrOrganizer.results = results;
                                $scope.Content.outings.playerOrOrganizer.isLoaded = true;
                                return $q.when();
                            };

                            return app.Member.Network.Data.Outings.playerOrOrganizer.fetch(true).then(function (data) {
                                return processData(data);
                            });

                        }
                     }
                       , groups: {
                           results: []
                           , isLoaded: false
                           , fetch: function (isRefresh) {
                               var processData = function (results) {

                                   var outings = [];
                                   for (var o = 0; o < results.length; o++) {
                                       //  if (results[o].)
                                   }

                                   $scope.Content.outings.groups.results = results;
                                   $scope.Content.outings.groups.isLoaded = true;
                                   return $q.when();
                               };
                               return ggOutingSvc.search.findAGame({ memberId: app.Member.Detail.id }).then(function (data) {
                                   return processData(data.data.value);
                               });
                           }
                       }
                     , select: function (outingId) {
                         ggFunctions.goToPage(app.modules.outing.routes.detail.path + "?outingId=" + outingId);
                     }
                     , refresh: function () {
                         if ($scope.Content.outings.tabs.current == $scope.Content.outings.tabs.types.player) {
                             $scope.Content.outings.player.fetch(true);
                         }
                         if ($scope.Content.outings.tabs.current == $scope.Content.outings.tabs.types.organizer) {
                             $scope.Content.outings.organizer.fetch(true);
                         }
                         if ($scope.Content.outings.tabs.current == $scope.Content.outings.tabs.types.playerOrOrganizer) {
                             $scope.Content.outings.playerOrOrganizer.fetch(true);
                         }
                     }
                  }
                  , groups: {
                      tabs: {
                          current: 2
                         , types: {
                             mygroups: 1
                            , following: 2
                            , myclub: 3
                            , nearme: 4
                         }
                         , isActive: function (t) {
                             return t == $scope.Content.groups.tabs.current;
                         }
                         , select: function (t) {
                             if (!t) {
                                 if ($scope.Content.groups.tabs.current = $scope.Content.groups.tabs.types.myclub) {
                                     if ($scope.Temp.upgrade.isRequired || !$scope.Content.clubs.showMembers) {
                                         $scope.Content.groups.tabs.current = 2;
                                     }
                                 }
                                 t = $scope.Content.groups.tabs.current;
                             }

                             //if (t == $scope.Content.groups.tabs.types.mygroups) {
                             $scope.Content.groups.mygroups.fetch();
                             //}
                             if (t == $scope.Content.groups.tabs.types.following) {
                                 $scope.Content.groups.following.fetch();
                             }
                             if (t == $scope.Content.groups.tabs.types.myclub) {
                                 $scope.Content.groups.myclub.fetch();
                             }
                             if (t == $scope.Content.groups.tabs.types.nearme) {
                                 $scope.Content.groups.nearme.fetch();
                             }

                             $scope.Content.groups.tabs.current = t;
                             app.Member.Session.bookmark.home.tab2 = t; // Remember Second tab.
                             $scope.f.scrollLimit.reset(); // Reset Scroll limit
                         }
                      }
                     , following: {
                         results: []
                        , isLoaded: false
                        , fetch: function (isRefresh) {

                            var processData = function (results) {

                                for (var r = 0; r < results.length; r++) {
                                    results[r] = ggFunctions.formatMemberName(results[r]);
                                }

                                if (results.length > 0) {
                                    // Sort on date
                                    results.sort(function (a, b) {
                                        var d1 = a.lastName;
                                        var d2 = b.lastName;
                                        var v = d1 > d2 ? 1 : d1 < d2 ? -1 : 0;
                                        return v;
                                    });
                                }

                                $scope.Content.groups.following.results = results
                                $scope.Content.groups.following.isLoaded = true;
                                return $q.when();
                            }

                            return app.Member.Network.Data.Friends.fetch(true).then(function (data) {
                                return processData(data);
                            });
                        }
                        , select: function (memberId) {
                            //ggFunctions.goToPage(app.modules.group.routes.detail.path + "?groupId=" + groupId);
                        }
                        , swipe: {
                            selected: 0
                           , isPartner: false

                           , left: function (memberId) {
                               $scope.Content.groups.following.swipe.isPartner = false;
                               if ($scope.f.isPartner(memberId)) {
                                   $scope.Content.groups.following.swipe.isPartner = true;
                               }
                               $scope.Content.groups.following.swipe.selected = memberId;
                           }
                           , right: function (memberId) {
                               $scope.Content.groups.following.swipe.selected = 0;
                               $scope.Content.groups.following.swipe.isPartner = false;
                           }
                           , isSelected: function (memberId) {
                               return memberId == $scope.Content.groups.following.swipe.selected
                           }
                        }
                     }
                     , nearme: {
                         results: []
                        , isLoaded: false
                        , fetch: function (isRefresh) {
                            var processData = function (results) {
                                $scope.Content.groups.nearme.results = results
                                $scope.Content.groups.nearme.isLoaded = true;
                                return $q.when();
                            }

                            return app.Member.Network.Data.Groups.nearme.fetch(true).then(function (data) {
                                return processData(data);
                            });
                        }
                        , select: function (groupId) {
                            ggFunctions.goToPage(app.modules.group.routes.detail.path + "?groupId=" + groupId);
                        }
                     }
                     , partners: {
                         results: []
                        , isLoaded: false
                        , fetch: function (isRefresh) {

                            var processData = function (results) {

                                if (results.length > 0) {
                                    // Sort on date
                                    results.sort(function (a, b) {
                                        var d1 = a.name;
                                        var d2 = b.name;
                                        var v = d1 > d2 ? 1 : d1 < d2 ? -1 : 0;
                                        return v;
                                    });
                                }

                                $scope.Content.groups.partners.results = results
                                $scope.Content.groups.partners.isLoaded = true;
                                return $q.when();
                            }

                            return app.Member.Network.Data.Partners.fetch(true).then(function (data) {
                                return processData(data);
                            });

                        }
                        , select: function (memberId) {
                            //ggFunctions.goToPage(app.modules.group.routes.detail.path + "?groupId=" + groupId);
                        }
                        , swipe: {
                            selected: 0
                           , isPartner: false

                           , left: function (memberId) {
                               $scope.Content.groups.partners.swipe.isPartner = true;
                               if (!$scope.f.isPartner(memberId)) {
                                   $scope.Content.groups.partners.swipe.isPartner = false;
                               }
                               $scope.Content.groups.partners.swipe.selected = memberId;
                           }
                           , right: function (memberId) {
                               $scope.Content.groups.partners.swipe.selected = 0;
                               $scope.Content.groups.partners.swipe.isPartner = true;
                           }
                           , isSelected: function (memberId) {
                               return memberId == $scope.Content.groups.partners.swipe.selected
                           }
                        }
                     }
                     , mygroups: {
                         results: []
                        , isLoaded: false
                        , fetch: function (isRefresh) {
                            var processData = function (results) {
                                $scope.Content.groups.mygroups.results = results
                                $scope.Content.groups.mygroups.isLoaded = true;
                                return $q.when();
                            }

                            if ($scope.Content.groups.mygroups.results.length == 0) {
                                return app.Member.Network.Data.Groups.allmygroups.fetch(true).then(function (data) {
                                    return processData(data);
                                });
                            }
                        }
                        , select: function (groupId) {
                            ggFunctions.goToPage(app.modules.group.routes.detail.path + "?groupId=" + groupId);
                        }
                     }
                     , myclub: {
                         results: []
                        , filter: ""
                        , isLoaded: false
                        , fetch: function (isRefresh) {

                            var processData = function (results) {

                                var newresults = [];
                                for (var r = 0; r < results.length; r++) {
                                    if (results[r].member) {
                                        results[r].member = ggFunctions.formatMemberName(results[r].member);
                                        newresults.push(results[r]);
                                    }
                                }

                                if (newresults.length > 0) {
                                    // Sort on date
                                    newresults.sort(function (a, b) {
                                        var d1 = a.member.lastName;
                                        var d2 = b.member.lastName;
                                        var v = d1 > d2 ? 1 : d1 < d2 ? -1 : 0;
                                        return v;
                                    });
                                }

                                $scope.Content.groups.myclub.results = newresults
                                $scope.Content.groups.myclub.isLoaded = true;
                                return $q.when();
                            }

                            var clubId = app.Member.Detail.memberships[0].clubId;
                            return ggMemberSearchSvc.search.fetchMemberSearchByClub({ clubId: clubId }).then(function (data) {
                                return processData(data.data.value);
                            });
                        }
                        , select: function (memberId) {
                            //ggFunctions.goToPage(app.modules.group.routes.detail.path + "?groupId=" + groupId);
                        }
                     }
                  }
                  , clubs: {
                      results: []
                     , isLoaded: false
                     , showMembers: false
                     , loadProfile: function () {

                         var clubMembership = {};

                         if (app.Member.Detail.memberships && app.Member.Detail.memberships.length > 0) {
                             clubMembership = app.Member.Detail.memberships[0];
                         }
                         $scope.Content.handicap.membership = clubMembership;

                         // club // show members?
                         if (clubMembership && clubMembership.club && clubMembership.club.adminData && clubMembership.club.adminData.showClubMembers) {
                             $scope.Content.clubs.showClubMembers = true;
                             $scope.Content.groups.tabs.current = 3;
                         }


                         // Handicap
                         if (clubMembership.handicaps && clubMembership.handicaps.length > 0) {
                             for (var h = 0; h < clubMembership.handicaps.length; h++) {
                                 var hcp = clubMembership.handicaps[h];
                                 if (hcp.isOfficial) {
                                     $scope.Content.handicap.official.value = hcp.value == 99.9 ? "NH" : hcp.value;
                                     if (!isNaN($scope.Content.handicap.official.value)) {
                                         $scope.Content.handicap.official.value = $scope.Content.handicap.official.value;
                                         if ($scope.Content.handicap.official.value < 0) {
                                             $scope.Content.handicap.official.value = $scope.Content.handicap.official.value * -1;
                                             $scope.Content.handicap.official.prefix = "+";
                                         }
                                     }
                                     if (hcp.isRealTime) {
                                         $scope.Content.handicap.offical.name = "Golf Canada Handicap Factor"
                                     }
                                 } else {
                                     $scope.Content.handicap.trend.value = hcp.value == 99.9 ? "NH" : hcp.value;
                                     if (!isNaN($scope.Content.handicap.trend.value)) {
                                         $scope.Content.handicap.trend.value = $scope.Content.handicap.trend.value;
                                         if ($scope.Content.handicap.trend.value < 0) {
                                             $scope.Content.handicap.trend.value = $scope.Content.handicap.trend.value * -1;
                                             $scope.Content.handicap.trend.prefix = "+";
                                         }
                                     }
                                 }
                             }
                         }


                         // Check for Upgrade?
                         if (app.Member.Session.appSetup) {
                             $scope.Temp.upgrade.isIOSPurchase = app.Member.Session.appSetup.isIOSPurchase;
                         }
                         if (app.Member.Session.appSetup && (((app.Member.Session.appSetup.isInAppPurchase) && isCordova) || (app.Member.Session.appSetup.isInWebPurchase && !isCordova))) {
                             $scope.Temp.upgrade.isOnline = true;
                             var isUpgrade = true;

                             if (clubMembership.club && clubMembership.club.managementGroupId && clubMembership.club.managementGroupId != 22) {
                                 isUpgrade = false;
                             }

                             if (clubMembership && clubMembership.membershipStatus == "Active" && (clubMembership.membershipType == "Partial" || clubMembership.membershipType == "Full")) {
                                 if (clubMembership.isCompliant) {
                                     if (clubMembership.clubType != "NonHandicapping") {
                                         isUpgrade = false;
                                         // All Good
                                     } else {
                                         console.log("Club is not a handicap club.")
                                     }
                                 } else {
                                     console.log("Player is not compliant.")
                                 }
                             }

                             if (isUpgrade) {
                                 $scope.Temp.upgrade.isRequired = true;

                                 inIOSPurchase.initialize(); // IOS Init only if upgrade required

                                 var _fetchToken = function () {
                                     return app.Member.Network.FetchAuthToken();
                                 }
                                 var _fetchClub = function () {
                                     if (app.Member.Auth.authToken) {
                                         return app.Member.Network.FetchCompliantClub().then(function (data) {
                                             if (data) {
                                                 $scope.Temp.upgrade.isRequired = true;
                                                 $scope.Temp.upgrade.isAvailable = true;
                                                 $scope.Temp.upgrade.club = data.data;
                                             }
                                         }, function (fail) {
                                             $scope.Temp.upgrade.reason = "There was an error searching for an available club to join: " + fail.data.error.msg;
                                             return;
                                         });
                                     } else {
                                         return $q.resolve();
                                     }

                                 }

                                 _fetchToken().then(function () {
                                     return _fetchClub();
                                 }).finally(function () {
                                     $scope.Temp.upgrade.isSearch = true;
                                 });

                             } else {
                                 $scope.Temp.upgrade.isRequired = false;
                                 $scope.Temp.upgrade.isAvailable = false;
                             }
                         }


                         $scope.Content.clubs.isLoaded = true;



                     }
                  }
                  , scoring: {
                      tabs: {
                          current: 1
                         , types: {
                             recent: 1
                            , stats: 2
                         }
                         , isActive: function (t) {
                             return t == $scope.Content.scoring.tabs.current;
                         }
                         , select: function (t) {
                             if (!t) {
                                 t = $scope.Content.scoring.tabs.current;
                             }

                             if (t == $scope.Content.scoring.tabs.types.recent) {
                                 $scope.Content.scoring.recent.fetch();
                             }
                             if (t == $scope.Content.scoring.tabs.types.stats) {
                                 $scope.Content.scoring.stats.fetch().then(function () {
                                     $scope.Content.scoring.stats.isLoaded = true;
                                     return;
                                 });
                             }

                             $scope.Content.scoring.tabs.current = t;
                             app.Member.Session.bookmark.home.tab2 = t; // Remember Second tab.
                             $scope.f.scrollLimit.reset(); // Reset Scroll limit
                         }
                      }
                     , recent: {
                         isLoaded: false
                        , results: []
                        , fetch: function (isRefresh) {

                            var processData = function (results) {
                                $scope.Content.scoring.recent.results = results
                                $scope.Content.scoring.recent.isLoaded = true;
                                return $q.when();
                            }

                            var isCurrent = ggStorage.get(ggStorage.keys.scoring.recent.isCurrent);
                            var storeData = JSON.parse(ggStorage.get(ggStorage.keys.scoring.recent.data)) || [];


                            return ggScoringSvc.search.fetchScoresByMember({ memberId: app.Member.Detail.id }).then(function (data) {
                                return processData(data.data.value);
                            });

                        }
                     }
                     , inProgress: {
                         results: []
                        , fetch: function () {
                            var localScores = JSON.parse(ggStorage.get(ggStorage.keys.scoring.inProgress.data)) || [];
                            if (localScores && localScores.length > 0) {
                                $scope.Content.scoring.inProgress.results = localScores;
                            }
                            return $q.when();
                        }
                        , select: function (localScoreId) {
                            // getLocalScoreId
                            if (!$scope.Temp.isSwiper) {
                                ggFunctions.goToPage(app.modules.scoring.routes.postascore.path + "?localScoreId=" + localScoreId);
                            }
                        }
                        , swipe: {
                            selected: 0
                           , left: function (localScoreId) {
                               $scope.f.isSwiper();
                               $scope.Content.scoring.inProgress.swipe.selected = localScoreId;


                           }
                           , right: function (memberId) {
                               $scope.f.isSwiper();
                               $scope.Content.scoring.inProgress.swipe.selected = 0;
                               $scope.Content.scoring.inProgress.swipe.isPartner = false;
                           }
                           , isSelected: function (localScoreId) {
                               return localScoreId == $scope.Content.scoring.inProgress.swipe.selected
                           }
                        }
                     }
                     , select: function (scoreId) {
                         ggFunctions.goToPage(app.modules.scoring.routes.postascore.path + "?scoreId=" + scoreId);
                     }
                     , refresh: function () {
                         if ($scope.Content.scoring.tabs.current == $scope.Content.scoring.tabs.types.recent) {
                             $scope.Content.scoring.recent.fetch(true);
                         }
                     }
                     , stats: {
                         results: null
                        , isLoaded: false
                        , isStrokesGained: app.Member.Detail.preferenceSettings.trackStrokesGained
                        , fetch: function () {
                            return ggScoringSvc.stats.fetchStatsSummary({ memberId: app.Member.Detail.id }).then(function (data) {
                                if (data) {

                                    $scope.Content.scoring.stats.results = data.data;

                                    $timeout(function () {
                                        $scope.Content.scoring.stats.charts.render();
                                    }, 500);

                                }
                            }, function (fail) {
                                return;
                            }).finally(function () {
                                $scope.Content.scoring.stats.isLoaded = true;
                            });
                        }
                     , charts: {
                         size: {
                             fetch: function () {
                                 var maxW = 748;
                                 var win = ggFunctions.fetchWindowSize();
                                 var w = maxW;
                                 var h = (w * 0.5).toFixed(0);

                                 w = w - 64;

                                 // Summary
                                 if (win.width < maxW) {
                                     w = win.width;
                                     w = w - 32;
                                 }

                                 h = (w * 0.5).toFixed(0);

                                 $scope.Content.scoring.stats.charts.size.summary.width = w;
                                 $scope.Content.scoring.stats.charts.size.summary.height = h;

                             }
                            , summary: {
                                width: 0
                               , height: 0
                            }
                         }
                       , render: function () {

                           $scope.Content.scoring.stats.charts.size.fetch();
                           var summary = function () {
                               var ss = [];
                               var labels = [];
                               var solids = [];
                               var borders = [];

                               if (($scope.Content.scoring.stats.results.albatrosses || 0) > 0) {
                                   ss.push($scope.Content.scoring.stats.results.albatrosses);
                                   lables.push("Dbl. Eagles");
                                   solids.push(ggSettings.colors.chartSolids[0]);
                                   borders.push(ggSettings.colors.chartSolids[0])
                               }
                               ss.push($scope.Content.scoring.stats.results.eagles || 0);
                               labels.push("Eagles");
                               solids.push(ggSettings.colors.chartSolids[1]);
                               borders.push(ggSettings.colors.chartSolids[1])
                               ss.push($scope.Content.scoring.stats.results.birdies || 0);
                               labels.push("Birdies");
                               solids.push(ggSettings.colors.chartSolids[2]);
                               borders.push(ggSettings.colors.chartSolids[2])
                               ss.push($scope.Content.scoring.stats.results.pars || 0);
                               labels.push("Pars");
                               solids.push(ggSettings.colors.chartSolids[3]);
                               borders.push(ggSettings.colors.chartSolids[3])
                               ss.push($scope.Content.scoring.stats.results.bogeys || 0);
                               labels.push("Bogeys");
                               solids.push(ggSettings.colors.chartSolids[4]);
                               borders.push(ggSettings.colors.chartSolids[4])
                               ss.push($scope.Content.scoring.stats.results.doubles || 0);
                               labels.push("Doubles");
                               solids.push(ggSettings.colors.chartSolids[5]);
                               borders.push(ggSettings.colors.chartSolids[5])
                               if (($scope.Content.scoring.stats.results.others || 0) > 0) {
                                   ss.push($scope.Content.scoring.stats.results.others);
                                   labels.push("Others");
                                   solids.push(ggSettings.colors.chartSolids[6]);
                                   borders.push(ggSettings.colors.chartSolids[6])
                               }


                               var ssCnv = document.getElementById("chartScoringSummary").getContext("2d");
                               var ssChart = new Chart(ssCnv, {
                                   type: 'pie',
                                   options: {
                                       legend: {
                                           position: 'right'
                                            , labels: {
                                                fontColor: "#222"
                                              , fontStyle: "bold"
                                            }
                                           , responsive: true
                                       }
                                   },
                                   data: {
                                       labels: labels,
                                       datasets: [{
                                           label: 'Scoring',
                                           data: ss,
                                           backgroundColor: solids,
                                           borderColor: borders,
                                           borderWidth: 3
                                       }]
                                   }
                               });
                           }

                           var trend = function () {

                               var scores = [];
                               var putts = []
                               var labels = []
                               for (var x = 0; x < $scope.Content.scoring.recent.results.length; x++) {
                                   scores.push($scope.Content.scoring.recent.results[x].gross);
                                   labels.push(ggFunctions.formatDateString($scope.Content.scoring.recent.results[x].playDate, "mm/dd", null))
                                   putts.push($scope.Content.scoring.recent.results[x].stats && $scope.Content.scoring.recent.results[x].stats.puttCount ? $scope.Content.scoring.recent.results[x].stats.puttCount : 0)
                                   if (x == 19) {
                                       break;
                                   }
                               }
                               scores.reverse();
                               labels.reverse();
                               putts.reverse();

                               var ssCnv = document.getElementById("chartTrend").getContext("2d");
                               var ssChart = new Chart(ssCnv, {
                                   type: 'bar'
                                   , options: {
                                       legend: {
                                           labels: {
                                               fontColor: "#222"
                                             , fontStyle: "bold"
                                           }
                                           , responsive: true
                                       }
                                   }
                                   , data: {
                                       labels: labels
                                      , datasets: [{
                                          type: "line",
                                          label: 'Gross Score',
                                          data: scores,
                                          fill: false,
                                          lineTension: 0.2,
                                          backgroundColor: ggSettings.colors.chartSolids[3],
                                          borderColor: ggSettings.colors.chartBorders[3],
                                          borderCapStyle: 'butt',
                                          borderDash: [],
                                          borderDashOffset: 0.0,
                                          borderJoinStyle: 'miter',
                                          pointBorderColor: ggSettings.colors.chartSolids[3],
                                          pointBackgroundColor: ggSettings.colors.chartBorders[3],
                                          pointBorderWidth: 1,
                                          pointHoverRadius: 5,
                                          pointHoverBackgroundColor: ggSettings.colors.chartSolids[2],
                                          pointHoverBorderColor: ggSettings.colors.chartBorders[2],
                                          pointHoverBorderWidth: 2,
                                          pointRadius: 1,
                                          pointHitRadius: 10,
                                          spanGaps: false,
                                      }
                                      ,
                                      {
                                          type: "bar",
                                          label: "Putts",
                                          data: putts,
                                          backgroundColor: ggSettings.colors.chartSolids[5],
                                          borderColor: ggSettings.colors.chartBorders[5],
                                          borderWidth: 3
                                      }
                                      ]

                                   }
                               });
                           }

                           var strokesGained = function () {






                               var ssCnv = document.getElementById("chartStrokesGained").getContext("2d");
                               var ssChart = new Chart(ssCnv, {
                                   type: 'bar'
                                   , options: {
                                       legend: {
                                           labels: {
                                               fontColor: "#222"
                                            , fontStyle: "bold"
                                           }
                                       }
                                       , responsive: true
                                   }
                                   , data: {
                                       labels: [
                                           "Driving (" + ((($scope.Content.scoring.stats.results.drivingStrokesGained || 0) == 0) ? '- NA' : $scope.Content.scoring.stats.results.drivingStrokesGained.toFixed(1)) + ")"
                                           , "Approach (" + ((($scope.Content.scoring.stats.results.approachStrokesGained || 0) == 0) ? '- NA' : $scope.Content.scoring.stats.results.approachStrokesGained.toFixed(1)) + ")"
                                           , "Short Game (" + ((($scope.Content.scoring.stats.results.shortStrokesGained || 0) == 0) ? '- NA' : $scope.Content.scoring.stats.results.shortStrokesGained.toFixed(1)) + ")"
                                           , "Putting (" + ((($scope.Content.scoring.stats.results.puttingStrokesGained || 0) == 0) ? '- NA' : $scope.Content.scoring.stats.results.puttingStrokesGained.toFixed(1)) + ")"
                                           , "Total (" + ((($scope.Content.scoring.stats.results.totalStrokesGained || 0) == 0) ? '- NA' : $scope.Content.scoring.stats.results.totalStrokesGained.toFixed(1)) + ")"
                                       ],
                                       datasets: [
                                           {
                                               label: "Strokes Gained"
                                               , backgroundColor: [
                                                   (($scope.Content.scoring.stats.results.drivingStrokesGained || 0) > 0) ? ggSettings.colors.chartSolids[3] : ggSettings.colors.chartSolids[6]
                                                   , (($scope.Content.scoring.stats.results.approachStrokesGained || 0) > 0) ? ggSettings.colors.chartSolids[3] : ggSettings.colors.chartSolids[6]
                                                   , (($scope.Content.scoring.stats.results.shortStrokesGained || 0) > 0) ? ggSettings.colors.chartSolids[3] : ggSettings.colors.chartSolids[6]
                                                   , (($scope.Content.scoring.stats.results.puttingStrokesGained || 0) > 0) ? ggSettings.colors.chartSolids[3] : ggSettings.colors.chartSolids[6]
                                                   , (($scope.Content.scoring.stats.results.totalStrokesGained || 0) > 0) ? ggSettings.colors.chartSolids[3] : ggSettings.colors.chartSolids[6]
                                               ],
                                               borderColor: [
                                                   (($scope.Content.scoring.stats.results.drivingStrokesGained || 0) > 0) ? ggSettings.colors.chartBorders[3] : ggSettings.colors.chartBorders[6]
                                                   , (($scope.Content.scoring.stats.results.approachStrokesGained || 0) > 0) ? ggSettings.colors.chartBorders[3] : ggSettings.colors.chartBorders[6]
                                                   , (($scope.Content.scoring.stats.results.shortStrokesGained || 0) > 0) ? ggSettings.colors.chartBorders[3] : ggSettings.colors.chartBorders[6]
                                                   , (($scope.Content.scoring.stats.results.puttingStrokesGained || 0) > 0) ? ggSettings.colors.chartBorders[3] : ggSettings.colors.chartBorders[6]
                                                   , (($scope.Content.scoring.stats.results.totalStrokesGained || 0) > 0) ? ggSettings.colors.chartBorders[3] : ggSettings.colors.chartBorders[6]
                                               ],
                                               borderWidth: 1,
                                               data: [
                                                   $scope.Content.scoring.stats.results.drivingStrokesGained || 0
                                                   , $scope.Content.scoring.stats.results.approachStrokesGained || 0
                                                   , $scope.Content.scoring.stats.results.shortStrokesGained || 0
                                                   , $scope.Content.scoring.stats.results.puttingStrokesGained || 0
                                                   , $scope.Content.scoring.stats.results.totalStrokesGained || 0
                                               ],
                                           }
                                       ]
                                   }
                               });
                           }


                           chartStrokesGained
                           summary();
                           trend();
                           strokesGained();
                       }
                     }

                     }
                  }
                  , handicap: {
                      tabs: {
                          current: 1
                         , types: {
                             membership: 1
                            , revision: 2
                            , scores: 3
                         }
                         , isActive: function (t) {
                             return t == $scope.Content.handicap.tabs.current;
                         }
                         , select: function (t) {
                             if (!t) {
                                 t = $scope.Content.handicap.tabs.current;
                             }

                             if (t == $scope.Content.handicap.tabs.types.membership) {
                                 //$scope.Content.scoring.recent.fetch();
                             }
                             if (t == $scope.Content.handicap.tabs.types.revision) {
                                 $scope.Content.handicap.revision.fetch();
                             }
                             if (t == $scope.Content.handicap.tabs.types.scores) {
                                 $scope.Content.handicap.scores.fetch();
                             }

                             $scope.Content.handicap.tabs.current = t;
                             app.Member.Session.bookmark.home.tab2 = t; // Remember Second tab.
                             $scope.f.scrollLimit.reset(); // Reset Scroll limit
                         }
                      }
                     , membership: null
                     , official: {
                         value: null
                        , name: $sce.trustAsHtml("USGA Handicap Index®")
                        , isRealTime: false
                        , prefix: ""
                     }
                     , trend: {
                         value: null
                        , name: "Handicap Trend"
                        , prefix: ""
                     }
                     , refresh: function () {
                         if ($scope.Content.handicap.tabs.current == $scope.Content.handicap.tabs.types.membership) {
                             // $scope.Content.handicap.recent.fetch(true);
                         }
                         if ($scope.Content.handicap.tabs.current == $scope.Content.handicap.tabs.types.revision) {
                             $scope.Content.handicap.revision.fetch(true);
                         }
                     }
                     , revision: {
                         results: []
                        , select: function (revisionId) {

                            if (revisionId != $scope.Content.handicap.revision.selected.revisionId) {
                                $scope.Content.handicap.revision.selected.revisionId = revisionId;
                                $scope.Content.handicap.revision.selected.scores = [];
                                $scope.Content.handicap.revision.selected.fetch();
                            } else {
                                $scope.Content.handicap.revision.selected.revisionId = 0;
                                $scope.Content.handicap.revision.selected.scores = [];
                            }

                        }
                        , fetch: function (isActive) {

                            var processData = function (results) {
                                // Sort on name

                                if (results.length > 0) {
                                    results.sort(function (a, b) {
                                        var d1 = a.effectiveOn;
                                        var d2 = b.effectiveOn;
                                        var v = d1 > d2 ? -1 : d1 < d2 ? 1 : 0;
                                        return v;
                                    });
                                }


                                // Get Trend and Official Handicaps
                                if (results.length > 0) {
                                    for (var r = 0; r < results.length; r++) {
                                        var rev = results[r];
                                        if (rev && rev.value) {
                                            results[r].prefix = "";
                                            results[r].value = rev.value;
                                            if (results[r].value < 0) {
                                                results[r].prefix = "+";
                                                results[r].value *= -1;
                                            }
                                        }
                                    }
                                }

                                // Assign to page.
                                $scope.Content.handicap.revision.results = results;
                                $scope.Content.handicap.revision.isLoaded = true;

                                return $q.when();
                            }

                            return ggHandicapSvc.search.fetchRevisionsByClubMembership({ membershipId: $scope.Content.handicap.membership.id }).then(function (data) {
                                return processData(data.data.value);
                            }, function (fail) {
                                // No Revision
                                return processData([]);
                            });

                        }
                        , selected: {
                            revisionId: 0
                           , scores: []
                           , fetch: function () {
                               ggFunctions.toggleProcessing(true);

                               var form = {
                                   memberId: null
                                  , clubId: null
                                  , revisionId: $scope.Content.handicap.revision.selected.revisionId
                               }

                               ggHandicapSvc.search.fetchScoresByRevisionId(form).then(function (data) {
                                   if (data && data.status == "200") {
                                       $scope.Content.handicap.revision.selected.scores = data.data.value;
                                   }

                               }, function (error) {
                                   $scope.Content.handicap.revision.selected.revisionId = 0;
                                   $scope.PopupAlert.fail("Fore!", "There was an error fetching the revision scores.")
                               }).finally(function () {
                                   ggFunctions.toggleProcessing(false);
                               });
                           }
                        }
                     }
                      , scores: {
                          results: []
                          , isLoaded: false
                          , fetch: function () {

                              var processRevision = function (results) {
                                  // Sort on name

                                  if (results.length > 0) {
                                      results.sort(function (a, b) {
                                          var d1 = a.effectiveOn;
                                          var d2 = b.effectiveOn;
                                          var v = d1 > d2 ? -1 : d1 < d2 ? 1 : 0;
                                          return v;
                                      });
                                  }


                                  // Get Trend and Official Handicaps
                                  if (results.length > 0) {
                                      for (var r = 0; r < results.length; r++) {
                                          var rev = results[r];
                                          if (rev && rev.value) {
                                              results[r].prefix = "";
                                              results[r].value = rev.value;
                                              if (results[r].value < 0) {
                                                  results[r].prefix = "+";
                                                  results[r].value *= -1;
                                              }
                                          }
                                      }
                                  }

                                  // Assign to page.
                                  $scope.Content.handicap.revision.results = results;
                                  $scope.Content.handicap.revision.isLoaded = true;

                                  return $q.when();
                              }

                              var fetchRevision = function () {
                                  if ($scope.Content.handicap.revision.results.length == 0) {

                                      return ggHandicapSvc.search.fetchRevisionsByClubMembership({ membershipId: $scope.Content.handicap.membership.id }).then(function (data) {
                                          return processRevision(data.data.value);
                                      }, function (fail) {
                                          // No Revision
                                          return processRevision([]);
                                      });
                                  } else {
                                      return $q.resolve();;
                                  }
                              }

                              if ($scope.Content.handicap.scores.results.length == 0) {
                                  fetchRevision().then(function () {
                                      var form = {
                                          memberId: null
                                          , clubId: null
                                          , revisionId: $scope.Content.handicap.revision.results[0].id
                                      }

                                      ggHandicapSvc.search.fetchScoresByRevisionId(form).then(function (data) {
                                          if (data && data.status == "200") {
                                              $scope.Content.handicap.scores.results = data.data.value;
                                          }

                                      }, function (error) {
                                          $scope.PopupAlert.fail("Fore!", "There was an error fetching the revision scores.")
                                      }).finally(function () {
                                          $scope.Content.handicap.scores.isLoaded = true;
                                          ggFunctions.toggleProcessing(false);
                                      });
                                  });
                              }
                          }
                      }
                  }
                  , upgrade: {
                      show: function (id, isPrepaid) {

                          var data = {
                              sourceItemId: $scope.Temp.upgrade.club.sourceItemID
                             , clubId: $scope.Temp.upgrade.club.clubID
                             , amount: ggSettings.stripe.products.clubMembership1Yr.amount
                             , clubName: $scope.Temp.upgrade.club.ClubName
                             , description: "1YR USGA Licensed Club Membership"
                             , productId: ggSettings.stripe.products.clubMembership1Yr.productId
                             , isSubscription: true
                             , isQuantity: false
                             , discountCode: null
                          }

                          if (id == 3) {
                              data.amount = ggSettings.stripe.products.clubMembership3Yr.amount;
                              data.description = "3YR USGA Licensed Club Membership";
                              data.productId = ggSettings.stripe.products.clubMembership3Yr.productId
                              data.isSubscription = false;
                          }

                          if (id == 5) {
                              data.amount = ggSettings.stripe.products.clubMembership5Yr.amount;
                              data.description = "5YR USGA Licensed Club Membership";
                              data.productId = ggSettings.stripe.products.clubMembership5Yr.productId
                              data.isSubscription = false;
                          }

                          if (isCordova && $scope.Temp.upgrade.isIOSPurchase == 1) {
                              if (inIOSPurchase)
                                  inIOSPurchase.order("AnnualClubMembership");
                          } else {
                              var callback = function (data) {
                                  $scope.PopupAlert.success("Success", data.msg);
                                  return app.Member.Authenticate.ValidateToken(true).then(function () {
                                      $scope.Content.clubs.loadProfile();
                                  });
                              }
                              data.callback = callback;
                              if (!isPrepaid) {
                                  ggUISvc.modal.open.checkout(data)
                              } else {
                                  ggUISvc.modal.open.prepaid(data)
                              }
                          }


                      }
                     , prepaid: function () {
                         var data = {
                             sourceItemId: ggSettings.stripe.products.prepaidCode.sourceItemId
                            , clubId: null
                           , amount: ggSettings.stripe.products.prepaidCode.amount
                           , clubName: "Prepaid Code"
                           , description: "1YR USGA Licensed Club Membership"
                             , productId: ggSettings.stripe.products.prepaidCode.productId
                           , isSubscription: false
                            , isQuantity: true
                            , discountCode: null
                         }

                         var callback = function (data) {
                             $scope.PopupAlert.success("Success", data.msg);

                             return app.Member.Network.Data.Clubs.fetch(true).then(function () {
                                 $scope.Content.clubs.fetch();
                                 app.Member.Authenticate.Broadcast();

                             });
                         }
                         data.callback = callback;
                         ggUISvc.modal.open.checkout(data)
                     }
                  }

               }

               // limiting scroll height
               angular.element($window).bind("scroll", function () {
                   var windowHeight = "innerHeight" in window ? window.innerHeight : document.documentElement.offsetHeight;
                   var body = document.body, html = document.documentElement;
                   var docHeight = Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight);
                   var windowBottom = windowHeight + window.pageYOffset;
                   if (windowBottom >= docHeight && !$scope.f.scrollLimit.isScrolling) {
                       $scope.f.scrollLimit.scroll();
                   }
               });

               // View Functions
               $scope.f = {
                   isSwiper: function () {
                       $scope.Temp.isSwiper = true;
                       $timeout(function () {
                           $scope.Temp.isSwiper = false
                       }, 1000);
                   }
                  , profilePicture: function () {
                      ggFunctions.goToPage(app.modules.member.routes.profile.path + "?pic")
                  }
                   , updateProfile: function () {
                       ggFunctions.goToPage(app.modules.member.routes.profile.path + "?dirty");
                   }
                   , clickScore: function (scoreId) {
                       ggFunctions.goToPage(app.modules.scoring.routes.scoredetail.path + "?scoreId=" + scoreId);
                   }
                  , scrollLimit: {
                      isScrolling: false
                     , current: ggSettings.defaultScrollLimit
                     , reset: function () {
                         $scope.f.scrollLimit.current = ggSettings.defaultScrollLimit;
                     }
                     , scroll: function () {

                         $scope.f.scrollLimit.isScrolling = true;
                         $scope.$apply();
                         $timeout(function () {
                             $scope.f.scrollLimit.current = $scope.f.scrollLimit.current + ggSettings.defaultScrollLimit;
                             $scope.f.scrollLimit.isScrolling = false;
                             $scope.$apply();
                         }, 200);
                     }
                  }
                  , toggleJumboContent: function () {
                      $scope.Temp.isJumboExpanded = !$scope.Temp.isJumboExpanded;
                  }
                  , formatDateString: function (d) {
                      return ggFunctions.formatDateString(d, "m/d/yyyy", null)
                  }
                  , formatScoreType: function (scoreType) {
                      return ggFunctions.formatScoreType(scoreType);
                  }
                  , getThemeName: function (i) {
                      return ggFunctions.fetchThemeById(i).className;
                  }
                  , unFollowMember: function (member) {
                      app.Member.Network.Data.Friends.unfollow(member).then(function (data) {
                          if (data) {
                              $scope.Content.groups.following.results = data;
                              //if (!$scope.f.isFollowing(member.id)) {
                              $scope.Content.groups.following.swipe.right(member.id);
                              //}
                          }
                      });
                  }
                  , selectMember: function (member) {
                      ggFunctions.goToPage(app.modules.member.routes.memberdetail.path + "?memberId=" + member.id)
                  }
                  , addPartner: function (member) {
                      app.Member.Network.Data.Partners.follow(member).then(function (data) {
                          if (data) {
                              if ($scope.f.isPartner(member.id)) {
                                  if ($scope.View.groups.current == "Following") {
                                      $scope.Content.groups.following.swipe.right(member.id);
                                  }
                                  if ($scope.View.groups.current == "Partners") {
                                      $scope.Content.groups.partners.swipe.right(member.id);
                                  }
                              }
                          }
                      });
                  }
                  , removePartner: function (member) {
                      app.Member.Network.Data.Partners.unfollow(member).then(function (data) {
                          if (data) {

                              if (!$scope.f.isPartner(member.id)) {
                                  if ($scope.View.groups.current == "Following") {
                                      $scope.Content.groups.following.swipe.right(member.id);
                                  }
                                  if ($scope.View.groups.current == "Partners") {
                                      $scope.Content.groups.partners.swipe.right(member.id);
                                  }
                              }
                          }
                      });
                  }
                  , isPartner: function (memberId) {
                      return app.Member.Network.Data.Partners.isFollowing(memberId);
                  }
                  , isFollowing: function (memberId) {
                      return app.Member.Network.Data.Friends.isFollowing(memberId);
                  }
                  , deleteLocalScore: function (localScoreId) {
                      var storeData = JSON.parse(ggStorage.get(ggStorage.keys.scoring.inProgress.data)) || [];
                      if (storeData) {
                          for (var s = 0; s < storeData.length; s++) {
                              if (storeData[s].localScoreId == localScoreId) {
                                  storeData.splice(s, 1);
                                  ggStorage.set(ggStorage.keys.scoring.inProgress.data, storeData);
                                  $scope.Content.scoring.inProgress.results = storeData;
                                  break;
                              }
                          }
                          $scope.Content.scoring.inProgress.swipe.right(localScoreId);
                      }
                  }
                   , updateTransaction: function (p) {
                       var transaction = null;
                       if (p && p.transaction) {
                           transaction = JSON.stringify(p.transaction);
                       }

                       var updatePayment = app.Member.Network.UpdateIOSPayment;

                       var form = {
                           receipt: transaction
                       }
                       if ($scope.Temp.upgrade.club && $scope.Temp.upgrade.club.clubID) {
                           form.clubId = $scope.Temp.upgrade.club.clubID;
                       } else {
                           form.clubId = app.Member.Detail.memberships[0].clubId;
                       }


                       ggFunctions.toggleProcessing(true);
                       updatePayment(form).then(function (data) {
                           // data.data.msg
                           return app.Member.Authenticate.ValidateToken(true).then(function () {
                               $scope.Content.clubs.loadProfile();
                               app.Member.Authenticate.Broadcast();
                               $scope.PopupAlert.success("Account Updated", "Your handicap club membership has been updated.");
                           });
                       }, function (fail) {
                           $scope.PopupAlert.fail("Error", fail.data.error.msg);
                       }).finally(function () {
                           ggFunctions.toggleProcessing(false);
                       });

                   }

               }



               // Initialize the object
               inIOSPurchase.initialize = function () {
                   //if (app.Member.Session.appSetup.isInAppPurchase) {
                   // document.addEventListener('deviceready', function () {
                   inIOSPurchase.initStore();
                   // }, true);
                   //}
               };

               // Object needs a store.
               inIOSPurchase.initStore = function () {

                   if (!window.store) {
                       $scope.Temp.isIOS = false;
                       return;
                   } else {
                       $scope.Temp.isIOS = true;
                   }

                   // Enable maximum logging level
                   store.verbosity = store.DEBUG;

                   // Inform the store of your products
                   store.register({
                       id: "AnnualClubMembership",
                       alias: "AnnualClubMembership",
                       type: window.store.PAID_SUBSCRIPTION
                   });

                   // When any product gets updated, refresh the HTML.
                   store.when("AnnualClubMembership").updated(function (p) {
                       //inAppPurchase.renderIAP(p);
                   });

                   store.when("AnnualClubMembership").approved(function (p) {
                       p.verify();
                   });

                   store.validator = function (p, cb) {
                       if ($scope.Temp.upgrade.isRequired) {
                           console.log("Store: Validator, current state: " + p.state);
                           $scope.f.updateTransaction(p);
                           p.finish();
                       }
                   }

                   // Log all errors
                   store.error(function (error) {
                       console.log('ERROR ' + error.code + ': ' + error.message);
                       //$scope.PopupAlert.fail("AppStore", "Unable to connect to appstore: " + error.message);
                   });


                   // Note that the "ready" function will be called immediately if the store
                   // is already ready.
                   store.ready(function () {
                       console.log("IOS Store is ready..");
                   });
                   store.refresh();
               };

               inIOSPurchase.order = function (pID) {
                   if (window.store) {
                       window.store.order("AnnualClubMembership");
                   } else {
                       $scope.PopupAlert.warn("Appstore", "Unable to connect to the Appstore.")
                   }
               }



               // Page Request Startup
               if ($routeParams) {
                   // delay initial pop
                   if (app.Member.Auth.isAuthenticated) {
                       $timeout(function () {

                           $scope.Temp.member.name = app.Member.Detail.firstName + " " + app.Member.Detail.lastName;
                           if (($scope.Temp.member.name).trim() == "") {
                               $scope.Temp.member.name = "Hi!";
                               $scope.Temp.member.city = "Welcome to GolfNet Groups."
                           } else {
                               if (app.Member.Detail.address && app.Member.Detail.address.city) {
                                   $scope.Temp.member.city = app.Member.Detail.address.city;
                               }
                               if (app.Member.Detail.address && app.Member.Detail.address.region) {
                                   $scope.Temp.member.region = app.Member.Detail.address.region;
                               }
                           }




                           $scope.Content.init();

                           // Registration Welcome?
                           if ($routeParams.postreg) {
                               if (!app.Member.Session.isWelcome) {

                                   var alert = new ggAlertSvc.popup;
                                   alert.classname = "welcome";
                                   alert.title = "";
                                   alert.description = "Welcome! You've installed the only app that tracks your USGA Handicap, all your golf scores and stats, AND manages your golf outings. Enjoy the app and hit 'em straight!"

                                   var btn = new ggAlertSvc.button;
                                   btn.name = "Close";
                                   btn.path = "";

                                   alert.buttons.push(btn);

                                   alert.show();
                                   app.Member.Session.isWelcome = true;
                               }
                           }

                       }, 150);

                   } else {
                       ggFunctions.goToPage(app.modules.view.routes.intro.path);
                   }
               }
               


            }
        }
    }


}(angular, app));
